<template>

  <div >
    <img :src="profilePic" class="profilePic" />
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'ProfilePicture',
  components: {
  },
  computed: {
    ...mapState({
      profilePic: state => state.admin.public_settings.profilePic
    })
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.profilePic {
  margin:10px;
  width: 80%;

}

</style>
